import { HHStack, HHTypography } from '@hinge-health/react-component-library';
import { SxProps } from '@mui/material/styles';
import { PropsWithChildren } from 'react';

interface TextGroupingProps {
  label: string;
  text: string | JSX.Element;
  sx?: SxProps;
}

export const TextGrouping = ({
  label,
  text,
  sx,
}: TextGroupingProps): JSX.Element => (
  <TextGroupingChildren sx={sx} label={label}>
    {text}
  </TextGroupingChildren>
);

export const TextGroupingChildren = ({
  label,
  children,
  sx,
}: PropsWithChildren<{
  label: string;
  sx?: SxProps;
}>): JSX.Element => (
  <HHStack sx={sx}>
    <HHTypography hhVariant="muted" fontSize={12}>
      {label}
    </HHTypography>
    <HHTypography
      hhVariant="variant-bypass"
      variant="body2"
      color="success"
      fontSize={12}
    >
      {children}
    </HHTypography>
  </HHStack>
);
